"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = exports.getSelectableMenuOptions = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

function getSelectableMenuOptions(options) {
  return options.filter(function (opt) {
    return opt !== 'divider';
  });
}

exports.getSelectableMenuOptions = getSelectableMenuOptions;

function Dropdown(_ref) {
  var children = _ref.children,
      options = _ref.options,
      selectedOptions = _ref.selectedOptions,
      onOptionSelected = _ref.onOptionSelected,
      disabled = _ref.disabled;
  var selectableOptions = getSelectableMenuOptions(options);
  var stringifiedOptions = selectedOptions.map(function (opt) {
    return JSON.stringify((opt === null || opt === void 0 ? void 0 : opt.value) || '');
  });
  return react_1.default.createElement(antd_1.Dropdown, {
    disabled: disabled,
    overlay: react_1.default.createElement(antd_1.Menu, {
      selectedKeys: stringifiedOptions,
      onClick: function onClick(_ref2) {
        var key = _ref2.key;

        if (onOptionSelected) {
          var selectedOption = selectableOptions.find(function (opt) {
            return opt.value === JSON.parse(key);
          });

          if (selectedOption) {
            onOptionSelected(selectedOption);
          }
        }
      }
    }, options.map(function (option, index) {
      if (option === 'divider') {
        return react_1.default.createElement(antd_1.Menu.Divider, {
          key: "divider-".concat(index)
        });
      } else {
        return react_1.default.createElement(antd_1.Menu.Item, {
          key: JSON.stringify(option.value),
          icon: option.icon
        }, option.label);
      }
    })),
    trigger: ['click'],
    children: children
  });
}

exports.Dropdown = Dropdown;